import React from 'react'
import ProductItems from '../Products/ProductItems'

export default function Products() {
  return (
    <div>
      <ProductItems/>
    </div>
  )
}
